import "./styles/global.css";
import React, { useState } from "react";
import homeguardLogo from "./assets/homeguard-logo.png";
import SearchForm from "./components/SearchForm/SearchForm";
import { getInspectionPrices } from "./services/PaytraceServices";
import SearchResults from "./components/SearchResults/SearchResults";
import PaymentSection from "./components/PaymentSection/PaymentSection";
import Receipt from "./components/Receipt/Receipt";

function App() {
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [showPaymentSection, setShowPaymentSection] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [receiptData, setReceiptData] = useState(null);

  const [billingRecords, setBillingRecords] = useState([]);

  // get all the related billing address
  const handleSearchAddress = async (address, zipCode, reportId) => {
    if (!address && !zipCode && !reportId) {
      alert("Please enter Address and ZIP Code.");
      return;
    }
    setIsLoading(true);

    try {
      const results = await getInspectionPrices(
        address,
        zipCode,
        reportId
      );
      setBillingRecords(results);
      setShowSearchResults(true);
      setShowPaymentSection(false);
    } catch (error) {
      console.error("Error fetching billing summary:", error);
      alert("Failed to fetch billing records.");
    } finally {
      setIsLoading(false);
    }
  };

  console.log("billing details", billingRecords);

  const handleReportSelect = (result) => {
    console.log("handleReportSelect", result);
    setSelectedRecord(result);
    setShowPaymentSection(true);
    setShowSearchResults(false);
    setShowReceipt(false);
  };

  const handlePaymentSuccess = (paymentData, customerInfo, billingData) => {
    setReceiptData({ paymentData, customerInfo, billingData });
    setShowReceipt(true);
    setShowPaymentSection(false);
    setShowSearchResults(false);
  };

  const handleBackToSearch = () => {
    setShowSearchResults(false);
    setShowPaymentSection(false);
    setShowReceipt(false);
    setSelectedRecord([]);
    setReceiptData(null);
  };

  return (
    <div className="container">
      <div className="app-header">
        <div className="header-content">
          <img
            src={homeguardLogo}
            alt="HomeGuard Incorporated"
            className="company-logo"
          />
          <h1>HomeGuard Payments Portal</h1>
        </div>
      </div>
      {!showSearchResults && !showPaymentSection && !showReceipt ? (
        <SearchForm onSearch={handleSearchAddress} isLoading={isLoading} />
      ) : (
        <div className="back-to-search">
          <button onClick={handleBackToSearch} className="back-button">
            ← Back to Search
          </button>
        </div>
      )}
      {showSearchResults && (
        <SearchResults
          onReportSelect={handleReportSelect}
          billingRecords={billingRecords}
        />
      )}
      {showPaymentSection && (
        <PaymentSection 
          record={selectedRecord} 
          handleBackToSearch={handleBackToSearch}
          onPaymentSuccess={handlePaymentSuccess}
        />
      )}
      {showReceipt && receiptData && (
        <div className="receipt-section">
          <Receipt
            paymentData={receiptData.paymentData}
            customerInfo={receiptData.customerInfo}
            billingData={receiptData.billingData}
          />
        </div>
      )}
    </div>
  );
}

export default App;
